<template>
  <v-main>
    <v-container>
      <v-card elevation="6">
        <v-card-title>
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add a Value
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.name"
                outlined
                label="Name *"
                prepend-inner-icon="mdi-format-list-text"
                :error-messages="errors.name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-select
                v-model="form.type"
                :items="typeItems"
                item-color="red"
                label="Select Type"
                outlined
              >
              </v-select>
            </v-col>
          </v-row>
          <v-btn
            :disabled="isLoading"
            :loading="isLoading"
            color="primary"
            @click="save"
          >
            Save Value
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "ValueCreatePage",
  data() {
    return {
      form: {
        name: "",
        role_id: 4,
        is_active: true,
      },
      typeItems: [
        { id: "0", text: "", value: "" },
        { id: "1", text: "VESSEL", value: "VESSEL" },
        { id: "2", text: "GENERAL", value: "GENERAL" },
      ],
      isLoading: false,
    };
  },
  methods: {
    async save() {
      try {
        this.isLoading = true;
        this.form.site_id = this.site.id;
        await axios.post("/values", this.form);
        this.isLoading = false;
        this.$router.push("/values");
      } catch (e) {
        console.log(e);
        this.isLoading = false;
      }
    },
  },
};
</script>
